export default class ProcessingMessageController {

    private static readonly MIN_DELAY_MS = 4000;
    private static readonly MAX_DELAY_MS = 8000;

    private timeoutId: ReturnType<typeof setTimeout>|null = null;
    private message = "";
    private lastKey: string|null = null;
    private active = false;

    constructor(
        private readonly keys: string[],
        private readonly translate: (key: string) => string,
        private readonly onChange: () => void,
    ) {
    }

    public sync(active: boolean): void {
        if (active === this.active) {
            return;
        }
        this.active = active;
        if (!active) {
            this.stop();
            return;
        }

        this.message = this.getRandomMessage();
        this.schedule();
    }

    public getMessage(): string {
        return this.message;
    }

    public destroy(): void {
        this.active = false;
        this.stop();
    }

    private stop(): void {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        this.message = "";
        this.lastKey = null;
    }

    private schedule(): void {
        const delay = Math.floor(
            Math.random() * (ProcessingMessageController.MAX_DELAY_MS - ProcessingMessageController.MIN_DELAY_MS + 1),
        ) + ProcessingMessageController.MIN_DELAY_MS;
        this.timeoutId = setTimeout(() => {
            if (!this.active) {
                return;
            }
            this.message = this.getRandomMessage();
            this.schedule();
            this.onChange();
        }, delay);
    }

    private getRandomMessage(): string {
        const availableKeys = this.keys.length > 1 && this.lastKey !== null
            ? this.keys.filter(key => key !== this.lastKey)
            : this.keys;
        const key = availableKeys[Math.floor(Math.random() * availableKeys.length)];
        this.lastKey = key;

        return this.translate(key);
    }

}
